import { DialogV2Props, Flex, StyleSystemProps } from '@withjoy/joykit';
import { styled } from '@withjoy/joykit/theme';

export const dialogOverrides: NonNullable<DialogV2Props['overrides']> = {
  Content: { props: { width: ['100%', '504px'] } },
  Body: { props: { paddingX: 0, paddingY: 0 } },
};

export const StyledInformationContainer = styled(Flex)``;
const informationContainerStyles: StyleSystemProps = {
  backgroundColor: 'mono2',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
};

export const StyledNextStepsButtonWrapper = styled(Flex)``;
const nextStepsButtonWrapperStyles: StyleSystemProps = {
  marginTop: { _: 5 },
  padding: { _: 5 },
  borderRadius: { _: 4 },
  border: '1px solid',
  borderColor: 'mono3',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
};

export const StyledInformationWrapper = styled(Flex)``;
export const informationWrapperStyles: StyleSystemProps = {
  width: '100%',
  paddingX: 9,
  paddingBottom: 9,
};

export const styles = {
  informationContainerStyles,
  informationWrapperStyles,
  nextStepsButtonWrapperStyles,
};
